import React from 'react'
import { useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import ClearOutlinedIcon from 'components/material-symbol/icons/Clear'
import { useStyles } from '../styles'

const MaxAttendance = () => {
  const { register, errors, setValue, watch } = useFormContext()
  const classes = useStyles()
  const maxAttendance = watch('maxAttendance')
  const clearMaxAttendance = () => setValue('maxAttendance', null)

  const hasMaxAttendance =
    maxAttendance !== null &&
    maxAttendance !== undefined &&
    maxAttendance !== ''

  return (
    <Box className={classes.fieldGroup} width="100%">
      <TextField
        name="maxAttendance"
        label="Max attendance"
        type="number"
        inputRef={register}
        placeholder="e.g. 24"
        error={!!errors.maxAttendance}
        helperText={
          errors?.maxAttendance?.message || 'Leave blank for unlimited.'
        }
        variant="outlined"
        fullWidth
        className={classes.fieldInput}
        InputProps={{
          inputProps: { min: 0 },
          endAdornment: hasMaxAttendance ? (
            <InputAdornment position="end">
              <IconButton
                onClick={clearMaxAttendance}
                aria-label="Clear max attendance"
              >
                <ClearOutlinedIcon />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    </Box>
  )
}

export default MaxAttendance
